module.exports = __webpack_public_path__ + "img/404.8db66c83.png";